import { useState } from "react"

export const SortableTh = ({ sortState, name, children }) => {
  return (
    <th onClick={sortState.onClick} name={name} style={{ cursor: 'pointer' }}>
      { sortState.sortBy === name ? (
        sortState.sortOrder === 'asc' ? '▲ ' : '▼ '
      ) : null }
      {children}
    </th>
  )
}

export const useSorter = (defaultSortBy = 'createdAt', defaultSortOrder = 'desc') => {
  const [state, setState] = useState([defaultSortBy, defaultSortOrder]);
  
  const onClick = (e) => {
    const sortBy = e.currentTarget.getAttribute('name');
    if (!sortBy) return;
    setState(([currentSortBy, currentSortOrder]) => {
      if (sortBy === currentSortBy) {
        const newSortOrder = currentSortOrder === 'asc' ? 'desc' : 'asc';
        return [sortBy, newSortOrder];
      }
      return [sortBy, 'asc'];
    });
  }

  return {
    sortBy: state[0],
    sortOrder: state[1],
    onClick,
    urlQuery: `orderBy=${state[0]}&orderAscending=${state[1] === 'asc' ? 'true' : 'false'}`,
  };
}